import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const adminToken = sessionStorage.getItem("adminToken");

  return adminToken ? children : <Navigate to="/admin/login" />;
};

export default ProtectedRoute;
